import React, { useEffect, useState } from "react";
import { Button, Modal } from "rizzui";
import { useFormik } from "formik";
import { toast } from "sonner";
import { StopsPhotosService } from "../../../services/preventive-stops/preventive-stops-photos/stopsPhotosService";
import Dropzone from "../../../components/dropzone/Dropzone";

interface AddPhotosModalProps {
    isOpen: boolean;
    onClose: () => void;
    refetch: () => void;
    stopId?: string;
}

export const AddPhotosModal: React.FC<AddPhotosModalProps> = ({ isOpen, onClose, refetch, stopId }) => {

    // STATES

    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState<File[]>([]);
    const [updateList, setUpdateList] = useState<boolean>(false);

    // FUNCTIONS

    const handleUpload = async () => {
        setLoading(true);
        try {
            const formData = new FormData();
            files.forEach((file, index) => {
                formData.append(`photos[${index}]`, file); 
            });
            formData.append('id', stopId || '');
            toast.promise(
                (new StopsPhotosService()).addStopPhoto(formData),
                {
                    loading: 'Subiendo nuevas fotos...',
                    success: () => {
                        refetch();
                        setUpdateList(!updateList);
                        return 'Fotos subidas correctamente';
                    },
                    error: (error) => {
                        console.error('Error uploading photos', error);
                        return 'Error subiendo fotos';
                    },
                }
            );
            onClose();

        } catch (error) {
            console.error('Error uploading photos:', error);
        } finally {
            setLoading(false);
        }
    };

    // FORMIK

    const formik = useFormik({
        initialValues: {
            stopId: '',
        },
        onSubmit: () => {
            handleUpload();
        },
    });

    useEffect(() => {
        if (isOpen) {
            formik.setFieldValue('stopId', stopId);
        }
    }, [isOpen, stopId, formik.setFieldValue]);

    // RENDER

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size='sm'
            overlayClassName='backdrop-blur'
            containerClassName='!max-w-xl !shadow-xl'
            className='z-[9999] [&_.pointer-events-none]:overflow-visible'
        >
            <div className='flex items-center justify-between p-4'>
                <h2 className='text-lg font-semibold text-gray-800 dark:text-white'>
                    Subir fotos de la parada
                </h2>
                <button onClick={onClose} className='text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
            <div className='m-auto px-7 pt-6 pb-4'>
                <form onSubmit={formik.handleSubmit}>
                    <div className='mb-4'>
                        <Dropzone
                            id={stopId || ''}
                            entity="preventiveStops"
                            setUpdateList={setUpdateList}
                            setFiles={setFiles}
                        />
                    </div>
                </form>
            </div>

            <div className='flex justify-center p-7'>
                <Button
                    onClick={() => formik.handleSubmit()}
                    color='primary'
                    disabled={loading}
                >
                    {loading ? 'Subiendo...' : 'Importar'}
                </Button>
            </div>
        </Modal>
    );
};

export default AddPhotosModal;
